import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  Button,
  useDisclosure,
  Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
} from '@chakra-ui/react'
import { GiHamburgerMenu } from 'react-icons/gi'
import { User } from './HeaderCustomer/User'

export function HeaderMobile({ menufilho, menupai, nomeUsuario, avatarUrl }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box display={{ base: 'flex', md: 'none' }} w="full" bg="gray.200" py={2} alignItems="center" justifyContent="space-between" px={2}>
      <Button as={GiHamburgerMenu} bgColor="#378BBF" color="white" onClick={onOpen} borderRadius={0} />
      <Drawer placement={'left'} onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px">Menu CRM Innovation</DrawerHeader>
          <DrawerBody>
            <Flex flexDirection="column" alignItems="flex-start" flex="1">
              {menupai.map((item, index) => {
                if (item !== 'Home') {
                  return (
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton _expanded={{ bg: 'gray.200', color: 'white' }}>
                          <Button variant="ghost" colorScheme="blue" size="sm" _hover={{ color: 'blue.500' }} _focus={{ boxShadow: 'none' }}>
                            {item}
                          </Button>
                        </AccordionButton>
                        <AccordionPanel display="flex" flexDirection="column" alignItems="flex-start">
                          {menufilho.map((itemfilho, index) => {
                            if (itemfilho.menupai === item) {
                              return (
                                <Button
                                  as={'a'}
                                  variant="ghost"
                                  colorScheme="blue"
                                  size="sm"
                                  _hover={{ color: 'blue.500' }}
                                  _focus={{ boxShadow: 'none' }}
                                  href={itemfilho.menulink}
                                >
                                  {itemfilho.menufilho}
                                </Button>
                              )
                            }
                          })}
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  )
                }
              })}
            </Flex>

            <Flex marginTop="1rem" flexDirection="column" alignItems="flex-start">
              <Button
                as={'a'}
                variant="ghost"
                colorScheme="blue"
                size="sm"
                _hover={{ color: 'blue.500' }}
                _focus={{ boxShadow: 'none' }}
                href="/meus-chamados"
                mb={2}
              >
                Meus Chamados
              </Button>

              <Button
                variant="ghost"
                colorScheme="red"
                size="sm"
                onClick={() => {
                  localStorage.removeItem('authentication')
                  window.location.href = '/login'
                }}
              >
                Sair
              </Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Flex alignItems="center" gap={2}>
        <User userName={nomeUsuario} avatarUrl={avatarUrl} />
      </Flex>
    </Box>
  )
}
